import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  noReccords: () => __(translations.globalSearchModal.noReccords, 'No records'),
  placeholder: () => __(translations.globalSearchModal.placeHolder, 'Search...'),
  title: () => __(translations.globalSearchModal.title, 'Search'),
};
